const VideoPlayingBar = () => {
  return (
    <>
      <div className="flex items-center">
        <span className="playing-bar" style={{ animationDelay: "0s" }}></span>
        <span className="playing-bar" style={{ animationDelay: "0.2s" }}></span>
        <span className="playing-bar" style={{ animationDelay: "0.4s" }}></span>
      </div>
    </>
  );
};

export default VideoPlayingBar;
